import { useEffect } from 'react';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { loadBotpress, useBotpress } from 'shared/modules/botpress/Botpress';

export function BotpressWebchat() {
  const botpress = useBotpress();

  useEffect(() => {
    void loadBotpress();
  }, []);

  useEffect(() => {
    if (botpress) {
      botpress.open();
      const { configuration } = botpress;

      botpress.config({ configuration: { ...configuration, radius: 0.5 } });
    }
  }, [botpress]);

  useEffect(() => {
    if (!botpress) return;

    return botpress.on('webchat:closed', () => {
      MobileAppBridge.closeScreen();
    });
  }, [botpress]);

  return <div id="bp-embedded-webchat" />;
}
